/**
 * Scrolls to the top of the page.
 * Uses the main content element (document.querySelector('main')) when present, otherwise the window.
 */
export function scrollToTop() {
  const main = document.querySelector('main');
  if (main) {
    main.scrollTo({ top: 0 });
  } else {
    window.scrollTo({ top: 0 });
  }
}
